import compact from 'lodash/compact';
import uniq from 'lodash/uniq';
import { observable } from 'mobx';

import type { SubscriptionData } from 'chaika-frontend-types/frontend-cms';
import { RenderedServiceList } from '@billing/ui/BillingPage/store/RenderedServiceList';
import { getTranslateByLocale } from '@chaika/i18n/helper';
import { ProtestAmountList } from '@insurance/store/models/ProtestAmountList';
import { ProtestList } from '@insurance/store/models/ProtestList';
import { ReferralList } from '@store/models/SystemFields/Referral';
import { Locale } from 'chaika-enums';

import { ProtestItemList } from './models/ProtestItemList';

export class ProtestStore {
    public static Name = 'protestStore' as const;

    @observable public protestList = new ProtestList();
    @observable public protestAmountList = new ProtestAmountList();
    @observable public protestListItems = new ProtestItemList();
    @observable public protestListBadDataItems = new ProtestItemList();
    @observable public usedRenderedServicesByEhrId = new Map<string, string[]>();

    @observable public referralList = new ReferralList();
    @observable public renderedServiceList = new RenderedServiceList();
    @observable public curentEhrSubscriptions: SubscriptionData[] = [];

    public getResponsibilities(): string[] {
        const responsibilityDefault: string[] = [
            getTranslateByLocale(Locale.Ru, 'doctorMistake'),
            getTranslateByLocale(Locale.Ru, 'referralCreatorMistake'),
            getTranslateByLocale(Locale.Ru, 'patientWillPay'),
            getTranslateByLocale(Locale.Ru, 'officeWillPay'),
            getTranslateByLocale(Locale.Ru, 'headWillPay'),
            getTranslateByLocale(Locale.Ru, 'insurerMistake'),
            getTranslateByLocale(Locale.Ru, 'underOtherProgram'),
            getTranslateByLocale(Locale.Ru, 'reSubmit'),
            getTranslateByLocale(Locale.Ru, 'alreadyTaken'),
            getTranslateByLocale(Locale.Ru, 'practiceWillPay'),
            getTranslateByLocale(Locale.Ru, 'clinicWillPay'),
        ];

        return uniq(
            compact([...responsibilityDefault, ...this.protestListItems.values.map(item => item.responsibility)]),
        );
    }
}

export const protestStore = new ProtestStore();
